var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',[_c('NavBar',{attrs:{"title":_vm.user.first_name + ' ' + _vm.user.last_name,"titleIcon":'mdi-account',"menuItems":_vm.menuItems}}),_c('v-container',{staticClass:"pt-10 mt-10"},[_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }